import React, { createRef, PureComponent } from 'react';
import styled from 'styled-components';
import { bool, func, string, object } from 'prop-types';

import MultiSelectDropdown from 'library/components/form-elements/multi-select-dropdown';
import { resolve } from 'library/helpers/path-resolver';
import withProfileFieldData from 'apps/journey/hoc/with-profile-field-data';
import { ParseBoolean } from 'library/helpers/text';
import { checkSelectionValidity } from 'apps/journey/forms/helpers/custom-validity-helpers';

const StyledContainer = styled.div`
  margin-bottom: 1em;
  &&& input {
    visibility: hidden;
    padding: 0;
    margin: 0;
    height: 0;
  }
`;

const ParseSelections = (choices, selections) => {
  const out = {};
  for (const choice of choices) {
    out[choice.key] = selections.indexOf(choice.key) > -1;
  }

  return out;
};

class ProfileMultiselect extends PureComponent {
  static propTypes = {
    label: string,
    onChange: func,
    value: bool,
    name: string,
    question: object,
    required: bool,
  };

  state = {
    selections: {},
    ignore: false,
  };

  constructor(props) {
    super(props);

    this.state.selections = ParseSelections(
      resolve(props.question, 'answer_choices', []),
      resolve(props.question, 'user_response/selected_answer_choices', []).map(
        (x) => x.key
      )
    );

    this.ref = createRef();
  }

  checkCustomValidity() {
    checkSelectionValidity(
      this.props.required,
      this.state.selections,
      this.ref
    );
  }

  componentDidMount() {
    this.checkCustomValidity();
  }

  handleOnChange = ({ target }) => {
    const { key, value } = target;

    const selections = {
      ...this.state.selections,
      [key]: !ParseBoolean(this.state.selections[key]),
    };

    try {
      this.props.onChange({
        target: {
          id: resolve(this.props.question, 'id', null),
          answer: selections,
        },
      });
      this.setState(
        {
          selections: selections,
        },
        this.checkCustomValidity
      );
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    let choices = resolve(this.props.question, 'answer_choices', []);
    if (!choices.length) {
      choices = resolve(this.props, 'options', []);
    }

    // convert selected or saved keys into a semicolon separated list of the
    // selection VALUES to display in the parent field
    const tvalue = Object.keys(this.state.selections)
      .filter((key) => (this.state.selections[key] ? key : null))
      .map(
        (selectedKey) =>
          choices.find((choice) => choice.key === selectedKey).value
      )
      .join('; ');

    return (
      <StyledContainer>
        <input ref={this.ref} />
        <MultiSelectDropdown
          onChange={this.handleOnChange}
          label={this.props.label}
          name={this.props.name}
          multiselect={true}
          value={tvalue}
          required={this.props.required}
          options={choices.map((x) => {
            return {
              key: x.key,
              value: x.value,
            };
          })}
        />
      </StyledContainer>
    );
  }
}

export default withProfileFieldData(ProfileMultiselect);
